const ACE_HOST='collectible-images.ams3.cdn.digitaloceanspaces.com';
export function slabImageUrl(slab,side,width){
  const original=slab.images?.[side];
  if(!original||!/^\d{4,12}$/.test(slab.cert||'')||!['front','back'].includes(side)||![320,720].includes(width))return original;
  try{
    const url=new URL(original);
    const imageCert=url.pathname.match(/^\/public\/collectible\/(\d{4,12})\//)?.[1];
    if(url.protocol!=='https:'||url.hostname!==ACE_HOST||url.username||url.password||!imageCert||imageCert.replace(/^0+(?=\d)/,'')!==slab.cert.replace(/^0+(?=\d)/,'')||url.pathname!==`/public/collectible/${imageCert}/${imageCert}_${side}.webp`)return original;
    return `/api/slab-image?cert=${imageCert}&side=${side}&w=${width}`;
  }catch{return original;}
}
